const _throttle = require('lodash.throttle');

window.addEventListener('load', function() {
    const siteHeader = document.getElementById('siteHeader');
    const headerPanels = document.querySelectorAll('.header-panel');

    if (siteHeader && headerPanels.length) {
        function checkIntersection() {
            const siteHeaderRect = siteHeader.getBoundingClientRect();
            const scrollPosition = window.scrollY;

            let isTouching = false;
            let isTouchingTop = false;

            headerPanels.forEach(panel => {
                const panelRect = panel.getBoundingClientRect();

                if (
                    siteHeaderRect.bottom > panelRect.top &&
                    siteHeaderRect.top < panelRect.bottom &&
                    siteHeaderRect.left < panelRect.right &&
                    siteHeaderRect.right > panelRect.left
                ) {
                    isTouching = true;
                }

                // Check if the bottom of the panel is intersecting with the siteHeader
                if (panelRect.bottom <= siteHeaderRect.bottom) {
                    isTouching = false;
                }
            });

            // Check if the siteHeader's scroll position is within 5px of the top of the document
            if (scrollPosition <= 5) {
                isTouchingTop = true;
            }

            if (isTouching) {
                siteHeader.setAttribute('data-nav-touching-header', 'true');
            } else {
                siteHeader.setAttribute('data-nav-touching-header', 'false');
            }

            if (isTouchingTop) {
                siteHeader.setAttribute('data-nav-touching-top', 'true');
            } else {
                siteHeader.setAttribute('data-nav-touching-top', 'false');
            }
        }

        const throttledCheckIntersection = _throttle(checkIntersection, 50);

        window.addEventListener('scroll', throttledCheckIntersection);
        window.addEventListener('resize', throttledCheckIntersection);

        checkIntersection();
    } else if (siteHeader) {
        siteHeader.setAttribute('data-nav-touching-header', 'false');
        siteHeader.setAttribute('data-nav-touching-top', 'false');
    }
});
